import type { SVGProps } from 'react'

export const Cart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox='0 0 74 74'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    style={{ fill: 'none' }}
    {...props}
  >
    <path
      d='M8.0057 11.9334H14.7569C15.814 11.9334 16.7354 12.6256 17.0135 13.6462L19.1724 21.7666M19.1724 21.7666L24.589 43.7C24.8671 44.7206 25.7885 45.4128 26.8457 45.4128H57.0724C58.1086 45.4128 59.0166 44.7464 59.3123 43.7555L65.5888 23.2663C65.9943 21.9107 64.98 20.529 63.5489 20.529H21.789C20.742 20.529 19.8261 21.0242 19.1724 21.7666ZM29.9224 58.1833C29.9224 60.3294 28.1852 62.0666 26.039 62.0666C23.8929 62.0666 22.1557 60.3294 22.1557 58.1833C22.1557 56.0372 23.8929 54.3 26.039 54.3C28.1852 54.3 29.9224 56.0372 29.9224 58.1833ZM58.7557 58.1833C58.7557 60.3294 57.0185 62.0666 54.8724 62.0666C52.7262 62.0666 50.989 60.3294 50.989 58.1833C50.989 56.0372 52.7262 54.3 54.8724 54.3C57.0185 54.3 58.7557 56.0372 58.7557 58.1833Z'
      strokeWidth='6'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

Cart.toString = () => 'cart'
